if (typeof QuantityProgressNotice !== 'function') {
  class QuantityProgressNotice extends HTMLElement {
    constructor() {
      super();
      this.updateProgressBar();
    }
    
    updateProgressBar() {
      // Calculate total quantity by summing all item quantities
      let totalQuantity = 0;
      const cartItems = this.closest('cart-form').querySelectorAll('[data-js-cart-item]');
      
      cartItems.forEach(item => {
        const itemQty = parseInt(item.getAttribute('data-qty') || 0);
        totalQuantity += itemQty;
      });
      
      const progressBar = this.querySelector('[data-quantity-progress-bar]');
      const textElement = this.querySelector('[data-quantity-progress-text]');
      const dots = this.querySelectorAll('.progress-dot');
      
      let progressPercentage = 0;
      let message = 'Add 3 items for 3 FOR 2 offer';
      
      if (totalQuantity === 1) {
        progressPercentage = 33;
        message = 'Every story starts with one.';
      } else if (totalQuantity === 2) {
        progressPercentage = 66;
        message = 'Now you´re close. Real close.';
      } else if (totalQuantity >= 3) {
        progressPercentage = 100;
        message = 'You earned it. 3 FOR 2 unlocked.';
      }
      
      if (progressBar) progressBar.style.width = progressPercentage + '%';
      if (textElement) textElement.textContent = message;
      
      // Update dots based on quantity
      dots.forEach((dot, index) => {
        const dotValue = parseInt(dot.getAttribute('data-dot'));
        
        // Handle each dot specifically by its data-dot value
        if (dotValue === 0) {
          // First dot (start-dot) is always active, never completed
          dot.classList.add('active');
          dot.classList.remove('completed');
        } 
        else if (dotValue === 1) {
          // Second dot (33%)
          if (totalQuantity >= 1) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
          
          if (totalQuantity >= 2) {
            dot.classList.add('completed');
          } else {
            dot.classList.remove('completed');
          }
        }
        else if (dotValue === 2) {
          // Third dot (66%)
          if (totalQuantity >= 2) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
          
          if (totalQuantity >= 3) {
            dot.classList.add('completed');
          } else {
            dot.classList.remove('completed');
          }
        }
        else if (dotValue === 3) {
          // Fourth dot (100%)
          if (totalQuantity >= 3) {
            dot.classList.add('active');
            dot.classList.add('completed');
          } else {
            dot.classList.remove('active');
            dot.classList.remove('completed');
          }
        }
      });
    }
    
    connectedCallback() {
      this.closest('cart-form').addEventListener('cart-updated', this.updateProgressBar.bind(this));
    }
    
    disconnectedCallback() {
      this.closest('cart-form').removeEventListener('cart-updated', this.updateProgressBar.bind(this));
    }
  }
  
  customElements.define('quantity-progress-notice', QuantityProgressNotice);
}